import mainCaller from './mainCaller';

const authHeaders = token => ({
  Authorization: `Bearer ${token}`,
  'Content-type': 'application/json',
});

export async function getAutoAttendanceSettings(branchId, token) {
  return await mainCaller(
    `admin/api/v1/branch-auto-attendance-settings?branchId=${branchId}`,
    'GET',
    null,
    authHeaders(token),
  );
}

export async function saveAutoAttendanceSettings(branchId, data, token) {
  return await mainCaller(
    `admin/api/v1/branch-auto-attendance-settings?branchId=${branchId}`,
    'PUT',
    data,
    authHeaders(token),
  );
}

export async function getUnconfirmedReservations(params, token) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value != null) query.append(key, value);
  });
  return await mainCaller(`admin/api/v1/reservations/unconfirmed?${query.toString()}`, 'GET', null, authHeaders(token));
}

// 엑셀용: 조건은 목록과 같고 페이지 없이 전부(기간 최대 6개월)
export async function exportUnconfirmedReservations(params, token) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value != null) query.append(key, value);
  });
  return await mainCaller(
    `admin/api/v1/reservations/unconfirmed/export?${query.toString()}`,
    'GET',
    null,
    authHeaders(token),
  );
}

// 출석·결석 처리된 예약 1건 변경 { reservationId, action: ATTEND|ABSENT|CANCEL }
export async function changeReservationAttendance(branchId, data, token) {
  return await mainCaller(
    `admin/api/v1/reservations/unconfirmed/change?branchId=${branchId}`,
    'POST',
    data,
    authHeaders(token),
  );
}

// 수업 관리 월 통계 (month = YYYY-MM)
export async function getClassAttendanceStats(branchId, month, token) {
  return await mainCaller(
    `admin/api/v1/reservations/unconfirmed/stats?branchId=${branchId}&month=${month}`,
    'GET',
    null,
    authHeaders(token),
  );
}

// 예약 처리 이력 (actions 는 배열 → 쉼표 구분)
export async function getReservationHistory(params, token) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length) query.append(key, value.join(','));
    } else if (value !== '' && value != null) {
      query.append(key, value);
    }
  });
  return await mainCaller(`admin/api/v1/reservations/unconfirmed/history?${query.toString()}`, 'GET', null, authHeaders(token));
}

export async function getReservationHistoryBatch(branchId, batchId, token) {
  return await mainCaller(
    `admin/api/v1/reservations/unconfirmed/history/batch/${batchId}?branchId=${branchId}`,
    'GET',
    null,
    authHeaders(token),
  );
}

export async function processUnconfirmedReservations(branchId, data, token) {
  return await mainCaller(
    `admin/api/v1/reservations/unconfirmed/process?branchId=${branchId}`,
    'POST',
    data,
    authHeaders(token),
  );
}
